import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/context-menu-input/context-menu-input.js';
      import {ContextMenuOption, ContextMenuType, ColumnGroup} from '@oicl/openbridge-webcomponents/dist/components/context-menu-input/context-menu-input.js';

      export interface Props {
     type?: ContextMenuType;
     options?: ContextMenuOption[];
     selectedValues?: string[];
     hasTitleBar?: boolean;
     title?: string;
     columnGroups?: ColumnGroup[];
     itemsPerColumn?: number;
     multiSelect?: boolean | undefined;
     selectPerGroup?: boolean | undefined
   }

      
  
      export type {ContextMenuOption, ContextMenuType, ColumnGroup} from '@oicl/openbridge-webcomponents/dist/components/context-menu-input/context-menu-input.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcContextMenuInput',
  props: {
    type: {},
    options: {},
    selectedValues: {},
    hasTitleBar: { type: Boolean },
    title: {},
    columnGroups: {},
    itemsPerColumn: {},
    multiSelect: { type: Boolean },
    selectPerGroup: { type: Boolean }
  },
  emits: ["change", "item-click", "close"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onChange: (event: CustomEvent<{selectedValues: string[], selectedOptions: ContextMenuOption[]}>) => emit('change', event as CustomEvent<{selectedValues: string[], selectedOptions: ContextMenuOption[]}>),
onItemClick: (event: CustomEvent<{value: string, option: ContextMenuOption}>) => emit('item-click', event as CustomEvent<{value: string, option: ContextMenuOption}>),
onClose: (event: CustomEvent<void>) => emit('close', event as CustomEvent<void>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-context-menu-input',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})